import { AlmanacMostSimilarFields } from "../AlmanacMostSimilarFields";
import { CreateCategoryDialogActions } from "portal/components/categoryCollectionProfile/createCategory/CreateCategoryDialogActions";
import { Field, Form, Formik } from "formik";
import { Skeleton } from "@mui/material";
import { TextField } from "formik-mui";
import { useAddNewCategoryForm } from "./useAddNewCategoryForm";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

type NewCategoryTemplateStepProps = {
  customerUuid?: string;
  onBack: () => void;
  onCancel: () => void;
  onSubmitSuccess: (newCategoryId: string) => void;
};

export const NewCategoryTemplateStep: FC<NewCategoryTemplateStepProps> = ({
  customerUuid,
  onBack,
  onCancel,
  onSubmitSuccess,
}) => {
  const { t } = useTranslation();
  const { almanacGroups, defaultAlmanacId, formConfig, isLoading } =
    useAddNewCategoryForm(customerUuid, onSubmitSuccess);

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <Skeleton variant="rectangular" className="h-14 w-full rounded" />
      </div>
    );
  }

  return (
    <Formik key={customerUuid ?? ""} {...formConfig}>
      {({ submitForm, isSubmitting }) => (
        <Form>
          <div className="flex flex-col gap-4">
            <Field
              component={TextField}
              name="name"
              label={t("components.categoryTemplates.fields.name")}
              fullWidth
            />
            <AlmanacMostSimilarFields
              almanacGroups={almanacGroups}
              defaultAlmanacId={defaultAlmanacId}
            />
          </div>
          <CreateCategoryDialogActions
            onBack={onBack}
            onCancel={onCancel}
            onConfirm={submitForm}
            confirmLabel={t("utils.actions.save")}
            confirmLoading={isSubmitting}
            disabled={isSubmitting}
          />
        </Form>
      )}
    </Formik>
  );
};
